export default {
  'bandWidth.topTitle': '带宽报告',
  'bandWidth.name': '带宽',
  'bandWidth.topTitle.text': '（请按照 utc+8 的时区查看数据。）',
  'bandWidth.menu.text1': '边缘位置',
  'bandWidth.menu.text2': '大洲',
  'bandWidth.menu.text3': 'CDN资源',
  'bandWidth.oneColumns.title2': '带宽',
};
